import styled from 'styled-components';

export const LandingPageStyled = styled.div``;

export const HeroSectionStyled = styled.div`
  padding: 80px 20px 0px;
  margin-bottom: 70px;

  & .hero-title {
    width: 100%;
    max-width: 880px;
    margin: 0 auto;
    margin-bottom: 60px;
    font-family: 'Inter';

    text-align: center;
    line-height: 54px;
    font-size: 32px;
  }

  & .hero-desc {
    line-height: 28px;
    text-align: center;
    color: #333;
    font-family: 'Inter';

    width: 100%;
    max-width: 650px;
    margin: 0 auto;
    margin-bottom: 60px;
  }

  @media (max-width: 820px) {
    & .hero-title {
      font-size: 24px;
      line-height: 45px;

      margin-bottom: 50px;
    }
    & .hero-desc {
      font-size: 16px;
      line-height: 28px;

      margin-bottom: 50px;
    }
  }
  @media (max-width: 500px) {
    & .hero-title {
      font-size: 18px;
      line-height: 32px;

      margin-bottom: 40px;
    }
    & .hero-desc {
      font-size: 14px;
      line-height: 25px;

      margin-bottom: 40px;
    }
  }
`;

export const DiscoverBannerStyled = styled.div`
  background: ${({ theme }) => theme.colors.blueShadow};
  padding: 60px 20px;
  margin: 30px 0px;

  & .discover-title {
    width: 100%;
    max-width: 880px;
    margin: 0 auto;
    margin-bottom: 50px;
    font-family: 'Inter';

    text-align: center;
    line-height: 54px;
    font-size: 32px;
  }

  & .discover-desc {
    line-height: 32px;
    font-size: 20px;
    text-align: center;
    color: #333;
    font-family: 'Inter';

    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }

  @media (max-width: 820px) {
    & .discover-title {
      font-size: 24px;
      line-height: 50px;

      margin-bottom: 30px;
    }
    & .discover-desc {
      font-size: 16px;
      line-height: 32 px;
    }
  }
  @media (max-width: 500px) {
    & .discover-title {
      font-size: 20px;
      line-height: 32px;

      margin-bottom: 20px;
    }
    & .discover-desc {
      font-size: 14px;
      line-height: 25px;
    }
  }
`;

export const SimpleSmartContainerStyled = styled.div`
  width: 100%;
  background-color: #f3f9fd;
  padding: 50px 10px;
`;

export const WrapperStyled = styled.div`
  max-width: 1250px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  justify-content: center;

  & .title {
    font-size: 32px;
    /* font-weight: 600; */
    @media (max-width: 960px) {
      text-align: center;
      line-height: 50px;
    }
  }
`;

export const StrategicChoiceStyled = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px 30px;

  display: flex;
  align-items: flex-start;
  gap: 50px;

  & .info-container {
    width: 430px;
    & .info-header {
      font-size: 32px;
      line-height: 50px;
      margin-bottom: 30px;
      font-family: 'Inter';
    }
    & .info-desc {
      font-size: 16px;
      line-height: 25px;
      margin-bottom: 30px;
      font-family: 'Inter';
    }

    & .btn-wrapper {
      display: flex;
      justify-content: flex-start;

      & button {
        border-radius: 28px;
        padding: 6px 16px;
      }
    }
  }

  & .card-grid-container {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    align-items: flex-start;
  }

  @media (max-width: 1024px) {
    & .info-container {
      width: 350px;
    }
    & .card-grid-container {
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }
  }

  @media (max-width: 820px) {
    flex-direction: column;
    & .info-container {
      width: 100%;
      & .info-header {
        font-size: 24px;
        text-align: center;
        margin-bottom: 20px;
      }
      & .info-desc {
        text-align: center;
      }

      & .btn-wrapper {
        justify-content: center;
      }
    }
    & .card-grid-container {
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
  }
  @media (max-width: 500px) {
    & .info-container {
      width: 100%;
      & .info-header {
        font-size: 20px;
        line-height: 32px;
      }
      & .info-desc {
        font-size: 14px;
      }
    }
  }
`;

export const StrategicCardStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  & .icon {
    height: 90px;
    width: 90px;
    margin-bottom: 20px;
  }

  & .title {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 20px;
    font-family: 'Inter';
  }

  & .desc {
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;
    margin-bottom: 20px;
    font-family: 'Inter';
  }
`;

export const LearnMoreButtonStyled = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  cursor: pointer;

  gap: 8px;
  & .learn-more {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-family: 'Inter';

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const WhyChooseUsStyled = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px 30px;

  display: flex;
  align-items: flex-start;
  gap: 50px;

  & .info-container {
    width: 430px;
    & .info-header {
      font-size: 32px;
      line-height: 50px;
      margin-bottom: 30px;
      font-family: 'Inter';
    }
    & .info-desc {
      font-size: 16px;
      line-height: 25px;
      margin-bottom: 30px;
      font-family: 'Inter';
    }
  }

  & .card-grid-container {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    align-items: flex-start;
  }

  @media (max-width: 1024px) {
    & .info-container {
      width: 350px;
    }
    & .card-grid-container {
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }
  }

  @media (max-width: 820px) {
    flex-direction: column;
    & .info-container {
      width: 100%;
      & .info-header {
        font-size: 24px;
        text-align: center;
        margin-bottom: 20px;
      }
      & .info-desc {
        text-align: center;
      }

      & .btn-wrapper {
        justify-content: center;
      }
    }
    & .card-grid-container {
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
  }
  @media (max-width: 500px) {
    & .info-container {
      width: 100%;
      & .info-header {
        font-size: 20px;
        line-height: 32px;
      }
      & .info-desc {
        font-size: 14px;
      }
    }
  }
`;

export const WhyChooseUsCardStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  & .icon {
    height: 90px;
    width: 90px;
    margin-bottom: 20px;
  }

  & .title {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 20px;
    font-family: 'Inter';
  }

  & .desc {
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;
    margin-bottom: 20px;
    font-family: 'Inter';
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
`;
